import { axiosInstanceV1 } from "@bn/api";

export interface AccountSelectGroup {
  /**
   * The group name
   */
  name: string;
  /**
   * The assigned accounts
   */
  accountIds: number[];
}

export interface CreateOrUpdateAccountSelectGroupParams {
  name?: string;
  accountIds?: number[];
}

export const upsertSelectedGroup = async (
  token: string | undefined,
  params: CreateOrUpdateAccountSelectGroupParams
) => {
  return axiosInstanceV1.post<AccountSelectGroup>(
    `/accounts/selectGroups`,
    params,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getSelectedGroup = async (
  token: string | undefined,
  name: string,
  accountType: string = "01_depot",
  excludeManuallyMaintainedFallbackAccounts: boolean = false
) => {
  // TODO: move query string params to arguments
  const { data } = await axiosInstanceV1.get<AccountSelectGroup>(
    `/accounts/selectGroups/${name}?fallbackAccountType%5B%5D=${accountType}&excludeManuallyMaintainedFallbackAccounts=${excludeManuallyMaintainedFallbackAccounts}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const createSelectGroups = async (
  token: string | undefined,
  payload: AccountSelectGroup
) => {
  const { data } = await axiosInstanceV1.post<AccountSelectGroup>(
    `/accounts/selectGroups`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};
